import type { Extrusion } from "geom/brep";
import type { PlanarGraphLoops } from "geom/planarGraph";
import { planeNewXY } from "geom/plane";
import type { PolyLine2 } from "geom/polyLine2Types";

export interface LevelPerimeters {
  readonly perimeters: PlanarGraphLoops;
  readonly perimeterPolyLine2s: PolyLine2[];
  readonly perimeterPolyLine2sWithoutExteriorFaces: PolyLine2[];
  readonly allPerimeterPolyLine2s: PolyLine2[];
}

export function levelPerimetersNew(
  perimeters: PlanarGraphLoops,
  perimeterPolyLine2s: PolyLine2[],
  perimeterPolyLine2sWithoutExteriorFaces: PolyLine2[],
  allPerimeterPolyLine2s: PolyLine2[],
): LevelPerimeters {
  return {
    perimeters,
    perimeterPolyLine2s,
    perimeterPolyLine2sWithoutExteriorFaces,
    allPerimeterPolyLine2s,
  };
}

/**
 * A simplified representation of a building volume that is an extrusion of the
 * interior faces of the building
 */
export interface LevelExtrusion {
  readonly perimeters: PolyLine2[];
  readonly minZ: number;
  readonly maxZ: number;
}

export function levelExtrusionsToExtrusions(levelExtrusions: LevelExtrusion[]): Extrusion[] {
  const extrusions: Extrusion[] = [];
  for (const levelExtrusion of levelExtrusions) {
    for (const perimeter of levelExtrusion.perimeters) {
      extrusions.push({
        type: "EXTRUSION",
        profile: {
          type: "FACE",
          loops: [perimeter],
          plane: planeNewXY(0, 0, levelExtrusion.minZ),
        },
        dirX: 0,
        dirY: 0,
        dirZ: levelExtrusion.maxZ - levelExtrusion.minZ,
      });
    }
  }
  return extrusions;
}
